<template>
	<div class="wrap">
		<div class="main">
			<div class="neibox">
				<div class="zhititle">
					修改密码
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						新密码
					</div>
					<el-input style="width: 230px;" placeholder="新密码" clearable>
					</el-input>
					<div class="chongtitle" style="color: #999999;padding-left: 10px;width: auto;">
						大小字母，数字，符号中的三种
					</div>
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						确认密码
					</div>
					<el-input style="width: 230px;" placeholder="确认密码" clearable>
					</el-input>
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						手机号
					</div>
					<div class="chongtitle">
						137****7123
					</div>
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						验证码
					</div>
					<el-input style="width: 230px;" placeholder="确认密码" clearable>
					</el-input>
					<el-button type="primary" style="margin-left: 15px;" @click="getSendSms">{{codeNewText}}</el-button>
				</div>
				<div class="chongbox">
					<div class="chongtitle">

					</div>
					<el-button type="primary" @click="subMit">确认</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				input: '',
				radio: '1',
				codeNewText:'发送验证码',
				newTime:60
			}
		},
		created() {

		},
		methods: {

			newCountdown() {
				intervalNewID = setInterval(() => {
					this.newTime--
					this.codeNewText = '倒计时 ' + this.newTime + ' 秒'
					if (this.newTime === 0) {
						this.isNewLoading = false
						this.newTime = 60
						this.codeNewText = '获取验证码'
					}
				}, 1000)
			},
			subMit(){
				this.resInterval()
			},
			resInterval() {
				clearInterval(intervalNewID)
				this.isNewLoading = false
				this.newTime = 60
				this.codeNewText = '获取验证码'
			},
			async getSendSms() {
				const res = await this.$api.getSendSms();
				this.newCountdown()
			},
		},

	}
</script>

<style>
	.neibox {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 5px;
	}

	.zhititle {
		font-size: 15px;
		color: #333333;
		border-bottom: 1px solid #dddddd;
		padding-bottom: 15px;
		margin-bottom: 15px;
	}

	.chongbox {
		display: flex;
		align-items: center;
		padding-bottom: 25px;
	}

	.chongtitle {
		font-size: 14px;
		color: #333333;
		width: 100px;
		text-align: right;
		flex-shrink: 0;
		margin-right: 15px;
	}

	.yubut {
		width: 208px;
		height: 40px;
		border-radius: 5px;
		padding: 0 10px;
		line-height: 40px;
		font-size: 14px;
		color: #333333;
		border: 1px solid #dedede;
	}
</style>